import { createFileRoute } from '@tanstack/react-router';

import { RequiredAttentionPage } from '@/features/approvals/required-attention.page';

export const Route = createFileRoute('/__authenticated/approvals/required-attention')({
	component: RequiredAttentionPage,
});
